import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import PrimaryButton from '../../../components/Buttons/PrimaryButton.js'
import ButtonPrevious from '../../../components/Buttons/ButtonPrevious.js'

const PGComponentNavStepper = styled.div`
  // 🎛
  // 🎨
  // 🖋
  font-family: 'Open Sans';
  width: 100%;
`;

const PGComponentWrapper = styled.div`
  // 📰
  padding-bottom: 10px;
  padding-top: 10px;
  margin: 0 auto;
  max-width: 1360px;
  margin-bottom: 100px;

  display: grid;
  grid-template-rows: 40px;
  grid-template-columns: 1fr 2fr 2fr 1fr;
  grid-template-areas:
  "sg_btn_previous sg_btn_wrapper sg_btn_wrapper sg_btn_next";
  .ButtonWrapper {
    .ButtonPrevious {
      grid-template-areas: sg_btn_previous;
    }
    .PrimaryButton {
      grid-template-areas: sg_btn_next;
    }
    .PrimaryButton {
      grid-template-areas: sg_btn_wrapper;
    }
  }
`;

const ButtonWrapper = styled.div`
`;


const EchoShipNavStepper = () => {
  return (
    <PGComponentNavStepper>
        <PGComponentWrapper>

        <ButtonPrevious>Previous</ButtonPrevious>
        <ButtonWrapper></ButtonWrapper>
        <ButtonWrapper></ButtonWrapper>

        <Link to="/BookShipment/SelectCarrier/">
            <PrimaryButton green>Continue</PrimaryButton>
        </Link>

        </PGComponentWrapper>

    </PGComponentNavStepper>
  )
}

export default EchoShipNavStepper;